import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=4cc8de8b&scoped=true&"
import script from "./DataCard.vue?vue&type=script&lang=ts&"
export * from "./DataCard.vue?vue&type=script&lang=ts&"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=4cc8de8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8de8b",
  null
  
)

export default component.exports